<template>
  <div class="content1">
    <h3 :style="{ width: lang == 'zh' ? '152px' : '220px' }">{{ $t('viewDetail.other') }}</h3>
    <div class="other_product">
      <!-- 轮播图开始 -->
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in RecommendExhibits" :key="index">
          <div class="parameter">
            <div class="title">{{ item.exhibitsName }}</div>
            <div class="english">{{ item.seriesName }}</div>
            <div class="txt">{{ item.column17 }}</div>
          </div>
          <div class="backImg">
            <img :src="item.exhibitsCoverImg.includes('http')?'':baseUrl + item.exhibitsCoverImg" alt="" v-if="item.exhibitsCoverImg.includes('http')" />
            <img src="../../../static/占位-展品-列表.png" alt="" v-else />
          </div>
          <div class="boxBottom">
            <span class="bottomTxt">{{ $t('viewDetail.more') }}</span>
            <span class="bottomImg">
              <img
                :src="item.collectStatus ? require('../../../static/collent_yello.png') : require('../../../static/collen1t.png')"
                alt=""
                @click="toggle(item)"
              />
            </span>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import { getOtherEx, collecExhibit } from '../../../../api/productCenter.js';
import { forMat } from '../../../../utils/common.js';

export default {
  name: 'exhibitorsLive',
  data() {
    return {
      baseUrl: forMat(),
      //swiper 初始化
      swiperOption: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 30,

        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: '',
          prevEl: '',
        },
      },
      RecommendExhibits: [],
      lang: '',
    };
  },
  props: ['zsId', 'zpId'],
  components: {
    swiper,
    swiperSlide,
  },
  created() {
    this.lang = localStorage.getItem('lang');
  },
  computed: {},

  methods: {
    // 切换产品的收藏
    async toggle(item) {
      // item.collectStatus = !item.collectStatus;
      const willStatus = !item.collectStatus;
      // 添加或者取消收藏
      const params = {
        objId: item.id,
        flag: willStatus,
        type: 2,
      };
      // const toggleStatus = item.collectStatus === true ? true : false;
      try {
        const { data } = await collecExhibit(params);
        if (data.code === 200) {
          if (!item.collectStatus) {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: '收藏成功！',
              type: 'success',
            });
          } else {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: '取消收藏成功！',
              type: 'error',
            });
          }
          this.getOtherExInfo();
        } else {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'warning',
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取其他展品信息
    async getOtherExInfo() {
      const params = { exhibitsId: this.zpId, exhibitorId: this.zsId };
      try {
        const { data } = await getOtherEx(params);
        // console.log("其他展品的数据是",data.data.length);
        if (data.data.length < 4) {
          this.swiperOption.navigation.nextEl = '';
          this.swiperOption.navigation.prevEl = '';
        }
        this.RecommendExhibits = data.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.getOtherExInfo();
    }, 1000);
  },
};
</script>
<style lang="scss" scoped>
.content1 {
  width: 1270px;
  margin-top: 114px;
  margin-bottom: 70px;
  h3 {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 28px;
    color: #006fb8;
    width: 152px;
    border-left: 3px solid #006fb8;
    border-right: 3px solid #006fb8;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
  .other_product {
    display: flex;
    position: relative;

    .swiper-container {
      width: 1205px;
    }
    .swiper-slide {
      width: 277px !important;
      height: fit-content;
      border: 1px solid #e0e0e0;
      margin-left: 0;
      background: #ffffff;
      margin: 15px 11px;
      &:hover {
        box-shadow: 0px 0px 15px 0px #b8bfc5;
      }

      //   margin-left: 28px;
      //   margin-bottom: 28px;
      .parameter {
        height: 150px;
        padding-top: 31px;
        box-sizing: border-box;
        .title {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          //margin-top: 30px;
          margin-left: 24px;
          font-size: 23px;
          max-width: 232px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          line-height: 26px;
        }
        .english {
          margin-top: 14px;
          margin-left: 24px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          max-width: 232px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .txt {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          margin-left: 24px;
          max-width: 232px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      .backImg {
        width: 232px;
        height: 172px;
        margin: 0px auto 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .companyName {
        margin: 19px 24px 20px 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .leftTitle {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          width: 203px;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 203px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .rightIcon {
          width: 18px;
          height: 18px;
          margin-left: 6px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .boxBottom {
        height: 64px;
        width: 277px;
        border-radius: 1px;
        border-top: 1px solid #e0e0e0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // border: 1px solid red;
        .bottomTxt {
          margin-left: 24px;
          cursor: pointer;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #006fb8;
        }
        .bottomImg {
          width: 30px;
          height: 28px;
          margin-right: 24px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .swiper-button-prev {
      width: 48px;
      height: 48px;
      margin-left: -8px;
      background-image: url('../../../static/left.png');
    }
    .swiper-button-next {
      background-image: url('../../../static/right.png');
    }
  }
}

.swiper-slide {
  height: 394px !important;
  width: 277px !important;
}
</style>
